import $ from "jquery";
import {CountUp} from "countup.js";

function initCounters(destination) {
    // Counter animation on numeric blocks
    let $numbers = $(destination.item).find('.srg-number-counter:not(.played)');
    if($numbers.length) {
        let easingFn = function (t, b, c, d) {
            var ts = (t /= d) * t;
            var tc = ts * t;
            return b + c * (tc + -3 * ts + 3 * t);
        }
        $numbers.each(function () {
            let decimals = $(this).attr('data-count-to').split('.')[1];
            let duration = $(this).attr('data-counter-duration');
            let counter = new CountUp($(this).attr('id'), $(this).attr('data-count-to'), {
                easingFn,
                duration: duration ? duration : 2,
                decimalPlaces: decimals ? 1 : 0,
                separator: '.',
                decimal: ',',
                suffix: $(this).attr('data-suffix'),
            });
            counter.start(() => $(this).addClass('played'));
        });
    }
}

export default {
    initCounters
}